<template>
  <div class="index">
    <div id="pcBox">
      <div class="videoBox" v-if="isPlayVideo">
        <div class="videoContent">
          <div class="close" :class="{'rotate':isRotate}" @click="closeVideo()"></div>
          <video
            src="https://files.easy2walk.com/mp4/cmappax.com/easy2walk_2_web2.mp4"
            autoplay
            controls
          ></video>
        </div>
      </div>
      <div class="banner listshow1" :class="{'none':isShowTuiguangForShangchang_Icon}">
        <img src="https://files.easy2walk.com/wwweasy2walk/img/pc/banner.png" alt />
        <div class="playVideo" @click="playVideo()">观看视频</div>
        <div class="phonebox">
          <img
            src="https://files.easy2walk.com/wwweasy2walk/img/pc/banner_phone1.png"
            class="banner_phone"
            :class="{'banner_phone1':isShowBanner_phone}"
            alt
          />
          <img
            src="https://files.easy2walk.com/wwweasy2walk/img/pc/banner_phone2.png"
            class="banner_phone"
            :class="{'banner_phone2':isShowBanner_phone}"
            alt
          />
        </div>
        <div class="shubiao"></div>
      </div>
      <transition name="el-zoom-in-top">
        <div class="head" v-show="isShowHead">
          <div class="logo">
            <img src="https://files.easy2walk.com/wwweasy2walk/img/pc/LOGO@2x.svg" alt />
          </div>
          <div class="nav">
            <div class="navBar" :class="{'changed':changedIndex==1}" @click="showDetails(1)">首页</div>
            <div class="navBar" :class="{'changed':changedIndex==2}" @click="showDetails(2)">功能</div>
            <div class="navBar" :class="{'changed':changedIndex==3}" @click="showDetails(3)">服务</div>
            <div class="navBar" :class="{'changed':changedIndex==4}" @click="showDetails(4)">支持</div>
          </div>
        </div>
      </transition>
      <div class="mainContent">
        <div class="mainImg">
          <div class="lyxLogo animated" :class="isShowLyxLogo ? 'fadeIn' :'fadeOut'">
            <img src="https://files.easy2walk.com/wwweasy2walk/img/pc/lyxLogo.svg" alt />
          </div>
          <div class="textContent animated" :class="isShowLyxLogo ? 'fadeIn' :'fadeOut'">
            在一个陌生的城市，语言不通、网络差异的情况下能在商场和商场快速容
            <br />易找到想买的商品和想吃的美食并查看导航路线和消费方式 。
          </div>
        </div>
        <div class="mainItem shangchang listshow2">
          <div class="shouji animated" :class="isShowShangchang ? 'pulse' :''"></div>
          <div
            class="sucai animated"
            :class="isShowShangchang_S ? 'fadeInRight' :''"
            v-show="isShowShangchang_S"
          ></div>
          <div class="tubiao"></div>
          <div class="title animated" :class="isShowShangchang ? 'fadeIn' :'fadeOut'">商场与商场之间容易找到</div>
          <div class="text animated" :class="isShowShangchang ? 'fadeIn' :'fadeOut'">
            Easy2Walk路易寻让你轻松地来往不同的商场景点 , 无需
            <br />使用不同的软件你都可以容易找到你就近的商场位置,同时
            <br />间可以店与店的导航同时间可以店与店的导航附近的商场。
          </div>
        </div>
        <div class="mainItem shop">
          <div class="shouji animated" :class="isShowShop ? 'pulse' :''"></div>
          <div
            class="sucai animated"
            :class="isShowShop_S ? 'fadeInLeft' :''"
            v-show="isShowShop_S"
          ></div>
          <div class="tubiao"></div>
          <div class="title animated" :class="isShowShop ? 'fadeIn' :'fadeOut'">简单直接让你找到店铺</div>
          <div class="text animated" :class="isShowShop ?'fadeIn' :'fadeOut'">
            Easy2Walk路易寻含有模拟导航系统,简单设定起点
            <br />和终点就可以根据导航快速找出您想去的店铺。
          </div>
        </div>
        <div class="mainItem pay">
          <div class="shouji animated" :class="isShowPay ? 'pulse' :''"></div>
          <div class="sucai animated" :class="isShowPay_S ? 'fadeInRight' :''" v-show="isShowPay_S"></div>
          <div class="tubiao"></div>
          <div class="title animated" :class="isShowPay ? 'fadeIn' :'fadeOut'">付款方式简单让你知道</div>
          <div class="text animated" :class="isShowPay ? 'fadeIn' :'fadeOut'">
            在一个陌生的地方, 你未必知道你的付款方式 能否使
            <br />用 Easy2Walk路易寻轻松提供付款资 讯让您购物时
            <br />作好准备 。
          </div>
        </div>
        <div class="mainItem food">
          <div class="shouji animated" :class="isShowFood ? 'pulse' :''"></div>
          <div
            class="sucai animated"
            :class="isShowFood_S ? 'fadeInLeft' :''"
            v-show="isShowFood_S"
          ></div>
          <div class="tubiao"></div>
          <div class="title animated" :class="isShowFood ? 'fadeIn' :'fadeOut'">美食从此不用等</div>
          <div class="text animated" :class="isShowFood ? 'fadeIn' :'fadeOut'">
            Easy2Walk路易寻为你推介附近的多
            <br />种国际菜肴和菜品, 同时提供人均消
            <br />费让你出门时更有预算。
          </div>
        </div>
        <div class="mainItem youhui">
          <div class="shouji"></div>
          <div class="sucai">
            <!-- <img
              v-for="i in 4"
              :key="i"
              :src="require(`../img/pc/youhui/img${i}.svg`)"
              alt
              class="imgItem"
              :class="{'imgTranslate' : isShowYouHui}"
            />-->
            <img
              v-for="i in 4"
              :key="i"
              :src="`https://files.easy2walk.com/wwweasy2walk/img/pc/youhui/img${i}.svg`"
              alt
              class="imgItem"
              :class="{'imgTranslate' : isShowYouHui}"
            />
          </div>
          <div class="tubiao"></div>
          <div class="title animated" :class="isShowYouHui ? 'fadeIn' :'fadeOut'">商场优惠推送</div>
          <div class="text animated" :class="isShowYouHui ? 'fadeIn' :'fadeOut'">
            第一时间推送最新的优惠活动
            <br />让商场消费者不再错过。
          </div>
        </div>
        <div class="tuiguangItem haiwai listshow3">
          <div class="topBg"></div>
          <div class="footBg"></div>
          <div
            class="phoneImg animated"
            :class="isShowHaiwai ? ' fadeInUp' :''"
            v-show="isShowHaiwai"
          ></div>
          <div
            class="phoneImg animated"
            :class="isShowHaiwai ? 'fadeInDown' :''"
            v-show="isShowHaiwai"
          ></div>
          <div class="title animated" :class="isShowHaiwai ? 'fadeIn' :'fadeOut'">海外推广</div>
          <div class="text animated" :class="isShowHaiwai ? 'fadeIn' :'fadeOut'">
            旅客去到一个陌生的地方，人生路不熟找不到路，语言不
            <br />通、怕菜式不合吃、买了不好的东西，怕找路不方便。
          </div>
        </div>
        <div class="tuiguangItem city">
          <div class="topBg"></div>
          <div class="footBg"></div>
          <div
            class="phoneImg animated"
            :class="isShowCity ? 'fadeInDown' :'fadeOutUp'"
            v-show="isShowCity"
          ></div>
          <div
            class="phoneImg animated"
            :class="isShowCity ? 'fadeInUp' :'fadeOutDown'"
            v-show="isShowCity"
          ></div>
          <div class="title animated" :class="isShowCity ? 'fadeIn' :'fadeOut'">城市推广</div>
          <div class="text animated" :class="isShowCity ? 'fadeIn' :'fadeOut'">
            对政府可推動当地旅游发展大帮助，管理和推动都是十分容易
            <br />加強城市的竞争力。
          </div>
          <div class="iconBox" :class="isShowCity ? 'fadeIn' :'fadeOut'">
            <div
              class="iconItem animated"
              v-for="(item,index) in iconDataForCity"
              :key="index"
              :class="isShowCity_icon ? 'fadeInUp' :''"
              :style="{'animation-delay':`${0.1*(index)}s` }"
            >
              <img
                :src="`https://files.easy2walk.com/wwweasy2walk/img/pc/city/icon${index+1}.png`"
                alt
              />
              <br />
              {{item}}
            </div>
          </div>
        </div>
        <div class="shangChangTuiGuang">
          <div class="topBg"></div>
          <div class="shouji animated" :class="{'fadeInDown':isShowTuiguangForShangchang}">
            <img
              src="https://files.easy2walk.com/wwweasy2walk/img/pc/shangchangtuiguang/shouji.png"
              alt
            />
          </div>
          <div
            class="imgItem animated"
            v-for="(item,i) in shangChangTuiGuangData"
            :key="i"
            :class=" [`imgItem${i+1}`,{'fadeInLeft':isShowTuiguangForShangchang && i+1< 3} ,{'fadeInRight':isShowTuiguangForShangchang && i+1>2}]  "
            :style="{'animation-delay':`${i>1?0.1*i:0.1*(3-i)}s` }"
          >
            <img
              :src="`https://files.easy2walk.com/wwweasy2walk/img/pc/shangchangtuiguang/img${i+1}.png`"
              alt
            />
            <br />
            {{item}}
          </div>
          <div
            class="title animated"
            :class="isShowTuiguangForShangchang ? 'fadeIn' :'fadeOut'"
          >商场推广</div>
          <div class="text animated" :class="isShowTuiguangForShangchang ? 'fadeIn' :'fadeOut'">
            减少客户排队询问的时间，让消费者手机扫二维码
            <br />即可找到自己想去的商铺。
          </div>
          <div class="saoma">扫二维码体验</div>
          <div class="bianjie">
            更便捷的服务
            <div class="icon"></div>
          </div>
          <div class="serveIconBox">
            <div
              class="serveIconItem animated"
              v-for="(item,index) in serveIconData"
              :key="index"
              :class="isShowTuiguangForShangchang_Icon ? 'fadeInUp' :'fadeOut'"
              :style="{'animation-delay':`${0.1*(index)}s` }"
            >
              <img
                :src="`https://files.easy2walk.com/wwweasy2walk/img/pc/shangchangtuiguang/serveIcon${index+1}.svg`"
                alt
              />
              <br />
              {{item}}
            </div>
          </div>
        </div>
        <div class="footerBox listshow4">
          <div class="bgBox">
            <div class="telUs">欢迎联系我们</div>
            <div class="mallBox">
              <img src="https://files.easy2walk.com/wwweasy2walk/img/pc/footer/mallBig.svg" alt />
              <span class="text">商务合作邮箱</span>
              <div class="icon"></div>
            </div>
            <a class="mallBtn" href="mailto:sw@chaunve.com" target="_blank">sw@chaunve.com</a>
          </div>
          <div class="bottomBox">
            <div class="copy">
              <i>Copyright Chaunve Technology Co., Ltd., All rights reserved</i>
              &nbsp;
            </div>
            <a href="https://beian.miit.gov.cn/" target="_blank"  class="beian">粤ICP备09008348号</a>
            <!-- <div class="mallBoxSmall">
              <img src="https://files.easy2walk.com/wwweasy2walk/img/pc/footer/mallSmall.svg" alt />
              <span>意见反馈邮箱：cuideng@chaunve.com</span>
            </div>-->
            <div class="logoBox">
              <a href="https://www.chaunve.com/" target="_blank">
                <img
                  src="https://files.easy2walk.com/wwweasy2walk/img/pc/footer/LOGO1@2x.svg"
                  alt
                  class="logoItem1"
                />
              </a>
              <img
                src="https://files.easy2walk.com/wwweasy2walk/img/pc/footer/LOGOfenge.svg"
                alt
                class="logoFenge"
              />
              <a href="#pcBox">
                <img
                  src="https://files.easy2walk.com/wwweasy2walk/img/pc/footer/LOGO2@2x.svg"
                  alt
                  class="logoItem2"
                />
              </a>
              <img
                src="https://files.easy2walk.com/wwweasy2walk/img/pc/footer/LOGOfenge.svg"
                alt
                class="logoFenge"
              />
              <a href="https://www.cmappax.com" target="_blank">
                <img
                  src="https://files.easy2walk.com/wwweasy2walk/img/pc/footer/LOGO3@2x.svg"
                  alt
                  class="logoItem3"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <mobile id="mobile" />
  </div>
</template>

<script>
import mobile from "./mobile.vue";
// https://files.easy2walk.com/wwweasy2walk/  图片CDN域名
// 国外https://hkfiles.easy2walk.com/wwweasy2walk/img/mobile/city/icon7.png

export default {
  name: "",
  components: {
    mobile
  },
  props: {},
  data() {
    return {
      isPlayVideo: false, //是否播放视频
      isRotate: false,
      changedIndex: 1,
      iconDataForCity: [
        "机场",
        "广告灯箱",
        "高铁站",
        "高铁车厢广告",
        "商场",
        "机场高铁站服务台",
        "旅游大使",
        "服务人员",
        "保安"
      ],
      serveIconData: [
        "最爱品牌",
        "寻路定位",
        "优惠推送",
        "大数据分析",
        "用户体验",
        "精准营销"
      ],

      shangChangTuiGuangData: [
        "只需手机扫描一个二维码，就可找到你想去的地方。",
        "在标示上加上二维码，就像一个流动标示。",
        "扫描二维码，互动屏的功能就直接到你手机便用。",
        "客服台上加一台小平版，客户可自行查询店铺寻路。"
      ],
      isShowBanner_phone: false,
      isShowHead: true, //是否显示头部
      isShowLyxLogo: false, //是否显示主图区域的logo和文字
      isShowShangchang: false, //是否显示商场的文字说明
      isShowShangchang_S: false,
      isShowShop: false, //是否显示店铺模块的文字说明
      isShowShop_S: false,
      isShowPay: false, //付款方式
      isShowPay_S: false,
      isShowFood: false, //美食不再等待
      isShowFood_S: false,
      isShowYouHui: false, //优惠

      isShowHaiwai: false, //海外推广
      isShowCity: false, //城市推广
      isShowCity_icon: false,
      isShowTuiguangForShangchang: false, //商场推广
      isShowTuiguangForShangchang_Icon: false
    };
  },
  created() {},
  mounted() {
    let that = this;
    window.addEventListener("scroll", this.handleScroll);
    let timer = setTimeout(() => {
      that.isShowBanner_phone = true;
      clearTimeout(timer);
    }, 1000);
    // console.log(window.screen.availWidth); //屏幕可用区的宽度
  },
  activited() {},
  update() {},
  beforeRouteUpdate() {},
  methods: {
    playVideo() {
      this.isPlayVideo = true;
      let timer = setTimeout(() => {
        this.isRotate = true;
        clearTimeout(timer);
      }, 100);
    },
    closeVideo() {
      this.isPlayVideo = false;
      this.isRotate = false;
    },
    showDetails(num) {
      this.changedIndex = num;
      var el = document.getElementsByClassName(`listshow${num}`)[0];
      var margin = document.getElementsByClassName(`listshow${1}`)[0]
        .offsetHeight;
      var head = document.getElementsByClassName(`head`)[0].offsetHeight;
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      let topNum = el.offsetTop;
      if (num != 1) {
        topNum = el.offsetTop + margin - 30;
        // topNum = el.offsetTop + el.offsetHeight +head*2
      }

      this.$nextTick(function() {
        window.scrollTo({
          behavior: "smooth",
          top: topNum
        });
      });
    },

    handleScroll() {
      let that = this;
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;

      var mainContentOffsetTop = document.querySelector(".mainContent")
        .offsetTop;
      var mainImgOffsetTop =
        document.querySelector(".mainImg").offsetTop + mainContentOffsetTop;
      var mainItemOffsetTop =
        document.querySelector(".mainItem").offsetTop + mainContentOffsetTop;

      //当主图区域滚动到顶部时头部显示
      // that.isShowHead = scrollTop - mainImgOffsetTop > -20 ? true : false;

      // 获取的是浏览器可见区域高度（网页的可视区域的高度）（不滚动的情况下）
      var documentClientHeight =
        document.documentElement.clientHeight || window.innerHeight;
      // 元素顶端到可见区域（网页）顶端的距离
      var mainImgHtmlElementClientTop = document
        .querySelector(".mainImg")
        .getBoundingClientRect().top;

      //商场距离网页顶端的距离
      var shangchangHtmlElementClientTop = document
        .querySelector(".shangchang")
        .getBoundingClientRect().top;
      //店铺
      var shopHtmlElementClientTop = document
        .querySelector(".shop")
        .getBoundingClientRect().top;
      //付款方式
      var payHtmlElementClientTop = document
        .querySelector(".pay")
        .getBoundingClientRect().top;
      //美食
      var foodHtmlElementClientTop = document
        .querySelector(".food")
        .getBoundingClientRect().top;
      //优惠
      var youHuiHtmlElementClientTop = document
        .querySelector(".youhui")
        .getBoundingClientRect().top;
      //海外推广
      var haiwai = document.querySelector(".haiwai").getBoundingClientRect()
        .top;
      //城市推广
      var city = document.querySelector(".city").getBoundingClientRect().top;
      //商场推广
      var shangChangTuiGuang = document
        .querySelector(".shangChangTuiGuang")
        .getBoundingClientRect().top;

      var margin =
        document.getElementsByClassName(`listshow${1}`)[0].offsetHeight - 40;
      var listshow1 =
        document.getElementsByClassName(`listshow${1}`)[0].offsetTop + margin;
      var listshow2 =
        document.getElementsByClassName(`listshow${2}`)[0].offsetTop + margin;
      var listshow3 =
        document.getElementsByClassName(`listshow${3}`)[0].offsetTop + margin;
      var listshow4 = document.getElementsByClassName(`listshow${4}`)[0]
        .offsetTop;
      // console.log("listshow4 :", listshow4, " scrollTop",scrollTop);
      if (scrollTop < listshow2) {
        that.changedIndex = 1;
        that.isShowBanner_phone = true;
      } else if (scrollTop < listshow3 && scrollTop > listshow2) {
        that.changedIndex = 2;
      } else if (scrollTop < listshow4) {
        that.changedIndex = 3;
      } else {
        that.changedIndex = 4;
      }
      if (scrollTop < 40) {
        that.isShowBanner_phone = true;
      } else {
        that.isShowBanner_phone = false;
      }
      // 主图进入可视区域
      that.isShowLyxLogo =
        documentClientHeight - mainImgHtmlElementClientTop >=
        document.querySelector(".mainImg").offsetHeight / 1.3
          ? true
          : false;
      // 商场与商场快速找到模块进入可视区
      if (
        documentClientHeight - shangchangHtmlElementClientTop >=
        document.querySelector(".shangchang").offsetHeight / 2
      ) {
        that.isShowShangchang = true;
        let timer = setTimeout(() => {
          that.isShowShangchang_S = true;
          clearTimeout(timer);
        }, 100);
      } else {
        that.isShowShangchang = false;
        that.isShowShangchang_S = false;
      }

      // 简单直接让你找到店铺
      if (
        documentClientHeight - shopHtmlElementClientTop >=
        document.querySelector(".shop").offsetHeight / 2
      ) {
        that.isShowShop = true;
        let timer = setTimeout(() => {
          that.isShowShop_S = true;
          clearTimeout(timer);
        }, 100);
      } else {
        that.isShowShop = false;
        that.isShowShop_S = false;
      }

      //付款方式
      if (
        documentClientHeight - payHtmlElementClientTop >=
        document.querySelector(".pay").offsetHeight / 2
      ) {
        that.isShowPay = true;
        let timer = setTimeout(() => {
          that.isShowPay_S = true;
          clearTimeout(timer);
        }, 100);
      } else {
        that.isShowPay = false;
        that.isShowPay_S = false;
      }

      // 美食
      if (
        documentClientHeight - foodHtmlElementClientTop >=
        document.querySelector(".food").offsetHeight / 2
      ) {
        that.isShowFood = true;
        let timer = setTimeout(() => {
          that.isShowFood_S = true;
          clearTimeout(timer);
        }, 100);
      } else {
        that.isShowFood = false;
        that.isShowFood_S = false;
      }

      // 优惠
      if (
        documentClientHeight - youHuiHtmlElementClientTop >=
        document.querySelector(".youhui").offsetHeight / 2
      ) {
        that.isShowYouHui = true;
      } else {
        that.isShowYouHui = false;
      }

      //海外推广
      if (
        documentClientHeight - haiwai >=
        document.querySelector(".haiwai").offsetHeight / 2
      ) {
        that.isShowHaiwai = true;
      } else {
        that.isShowHaiwai = false;
      }

      //城市推广
      if (
        documentClientHeight - city >=
        document.querySelector(".city").offsetHeight / 2
      ) {
        that.isShowCity = true;
      } else {
        that.isShowCity = false;
      }

      //商场推广
      if (
        documentClientHeight - shangChangTuiGuang >=
        document.querySelector(".shangChangTuiGuang").offsetHeight / 4
      ) {
        that.isShowTuiguangForShangchang = true;
      } else {
        that.isShowTuiguangForShangchang = false;
      }

      var serveIconBox = document
        .querySelector(".serveIconBox")
        .getBoundingClientRect().top;
      if (
        documentClientHeight - serveIconBox >=
        document.querySelector(".serveIconBox").offsetHeight * 2
      ) {
        that.isShowTuiguangForShangchang_Icon = true;
      } else {
        that.isShowTuiguangForShangchang_Icon = false;
      }

      var iconBox = document.querySelector(".iconBox").getBoundingClientRect()
        .top;
      if (
        documentClientHeight - iconBox >=
        document.querySelector(".iconBox").offsetHeight / 2
      ) {
        that.isShowCity_icon = true;
      } else {
        that.isShowCity_icon = false;
      }
    }
  },
  filter: {},
  computed: {},
  watch: {},
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  }
};
</script>

<style lang="scss" >
@import "@/assets/scss/global.scss";

/** iPhone **/
@media only screen and (min-width: 320px) and (max-width: 767px) {
  #mobile {
    display: block;
  }
  #pcBox {
    display: none;
  }
}

/** PC **/
@media only screen and (min-width: 768px) {
  #mobile {
    display: none;
  }
  #pcBox {
    display: block;
    width: 100%;
    height: auto;
  }

  .index {
    height: auto;
    .videoBox {
      width: 100%;
      height: 100%;
      position: fixed;
      top: 0;
      left: 0;
      z-index: 999;
      background-color: rgba(6, 8, 32, 0.83);
      .videoContent {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 7.2916666667rem;
        height: 3.6458333333rem;
        font-size: 0;
        .rotate {
          transition: all 0.3s linear;
          transform: rotateZ(180deg);
        }
        .close {
          position: absolute;
          top: 0;
          width: 0.2604166667rem;
          height: 0.2604166667rem;
          right: -0.1302166667rem;
          background: url("../img/close.svg") no-repeat 50%;
          background-size: contain;
          cursor: pointer;
          transition: all 0.3s linear;
          transform-origin: center center;
          z-index: 2;
          &:hover {
            transform: rotateZ(360deg);
          }
        }

        video {
          width: 100%;
          height: 100%;
          border: 0;
          outline: none;
          position: relative;
          z-index: 1;
          display: block;
        }
      }
    }
    .banner {
      width: px1920(1920);
      height: px1920(996);
      position: fixed;
      top: 0;
      left: 0;
      z-index: 1;
      overflow: hidden;
      opacity: 1;
      img {
        width: 100%;
        height: 100%;
      }
      .playVideo {
        width: px1920(167);
        height: px1920(47);
        border-radius: px1920(10);
        font-size: px1920(20);
        color: #fff;
        background-color: #f05d52;
        position: absolute;
        left: px1920(231);
        top: px1920(738);
        text-align: center;
        line-height: px1920(47);
        cursor: pointer;
        &:hover {
          background-color: #930c13;
        }
      }
      .phonebox {
        height: px1920(996);
        position: absolute;
        top: 0;
        left: px1920(1224);
        .banner_phone {
          width: px1920(278);
          height: px1920(1643);
          margin: 0 px1920(14);
          transform: translateY(px1920(-420));
          transition: transform 1s ease-in;
        }
        .banner_phone1 {
          transform: translateY(px1920(-260));
        }
        .banner_phone2 {
          transform: translateY(px1920(-580));
        }
      }
      .shubiao {
        width: px1920(53.33);
        height: px1920(67.5);
        background: url("https://files.easy2walk.com/wwweasy2walk/img/pc/shubiao.svg")
          center center no-repeat;
        background-size: 100% 100%;
        position: absolute;
        bottom: px1920(30);
        left: px1920(933);
        animation: shakeTopx 1s linear infinite;
      }

      @keyframes shakeTopx {
        0%,
        100% {
          -webkit-transform: rotate(0deg);
          transform: rotate(0deg);
          -webkit-transform-origin: bottom center;
          transform-origin: bottom center;
        }
        5% {
          -webkit-transform: rotate(2deg);
          transform: rotate(2deg);
        }
        10%,
        20%,
        30% {
          -webkit-transform: rotate(-4deg);
          transform: rotate(-4deg);
        }
        15%,
        25%,
        35% {
          -webkit-transform: rotate(4deg);
          transform: rotate(4deg);
        }
        40% {
          -webkit-transform: rotate(-2deg);
          transform: rotate(-2deg);
        }
        45% {
          -webkit-transform: rotate(2deg);
          transform: rotate(2deg);
        }
        50% {
          -webkit-transform: rotate(0deg);
          transform: rotate(0deg);
        }
      }
    }
    .none {
      opacity: 0;
    }
    .head {
      width: px1920(1920);
      height: px1920(84);
      position: fixed;
      top: 0;
      left: 0;
      background-color: rgba($color: #fff, $alpha: 1);
      z-index: 3;
      box-shadow: px1920(0) px1920(1) px1920(20) px1920(1) #ccc;
      .logo {
        width: px1920(150);
        height: px1920(84);
        position: absolute;
        left: px1920(113);
        img {
          height: px1920(44);
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
      }
      .nav {
        position: absolute;
        right: px1920(75);
        height: px1920(84);
        color: #371b2f;
        .navBar {
          font-size: px1920(18);
          padding: 0 px1920(38);
          display: inline-block;
          height: px1920(84);
          line-height: px1920(84);
          color: #371b2f;
          cursor: pointer;
        }
        .changed {
          color: #f15a53;
        }
      }
    }
    .mainContent {
      width: px1920(1920);
      height: auto;
      margin-top: px1920(976);
      background-color: #fff;
      // background: url("https://files.easy2walk.com/wwweasy2walk/img/pc/bg.png") top center no-repeat;
      // background-size: 100% auto;
      // background-color: #eee;
      position: relative;
      z-index: 2;
      overflow: hidden;

      .mainImg {
        height: px1920(521);
        width: px1920(1922);
        position: relative;
        background: url("https://files.easy2walk.com/wwweasy2walk/img/pc/mainIMG.png")
          center center no-repeat;
        background-size: 100% 100%;
        .lyxLogo {
          position: absolute;
          top: px1920(166);
          left: px1920(867);
          width: px1920(188);
          height: px1920(58);
          img {
            width: 100%;
            height: 100%;
          }
        }
        .textContent {
          color: #fff;
          font-size: px1920(18);
          text-align: center;
          width: px1920(638);
          line-height: px1920(35);
          position: absolute;
          top: px1920(260);
          left: px1920(641);
        }
      }
      .mainItem {
        position: relative;
        width: px1920(1920);
        height: px1920(800);
        // border-bottom: 1px dotted #371b2f;
        background: url("https://files.easy2walk.com/wwweasy2walk/img/pc/bg.png")
          top center no-repeat;
        background-size: 100% auto;
        text-align: center;
        &:nth-of-type(2n-1) {
          background-position: center px1920(-800);
        }
      }
      .shangchang {
        .shouji {
          position: absolute;
          left: px1920(862);
          top: px1920(86);
          height: px1920(649);
          width: px1920(336);
          background: url("https://files.easy2walk.com/wwweasy2walk/img/pc/shangchang/shouji.png")
            center center no-repeat;
          background-size: 100% 100%;
        }
        .sucai {
          position: absolute;
          left: px1920(1080);
          top: px1920(100);
          height: px1920(713);
          width: px1920(713);
          background: url("https://files.easy2walk.com/wwweasy2walk/img/pc/shangchang/sucai.png")
            center center no-repeat;
          background-size: 100% 100%;
        }
        .tubiao {
          position: absolute;
          left: px1920(444);
          top: px1920(250);
          height: px1920(110);
          width: px1920(110);
          background: url("https://files.easy2walk.com/wwweasy2walk/img/pc/shangchang/tubiao.svg")
            center center no-repeat;
          background-size: 100% 100%;
        }
        .title {
          position: absolute;
          left: px1920(288);
          top: px1920(373);
          font-size: px1920(44);
          color: #371b2f;
        }
        .text {
          position: absolute;
          left: px1920(290);
          top: px1920(455);
          font-size: px1920(18);
          line-height: px1920(35);
          color: #371b2f;
        }
      }
      .shop {
        .shouji {
          position: absolute;
          left: px1920(680);
          top: px1920(76);
          height: px1920(649);
          width: px1920(336);
          background: url("https://files.easy2walk.com/wwweasy2walk/img/pc/shop/shouji.png")
            center center no-repeat;
          background-size: 100% 100%;
        }
        .sucai {
          position: absolute;
          left: px1920(125);
          top: px1920(227);
          width: px1920(692.55);
          height: px1920(393);
          background: url("https://files.easy2walk.com/wwweasy2walk/img/pc/shop/sucai.png")
            center center no-repeat;
          background-size: 100% 100%;
        }
        .tubiao {
          position: absolute;
          left: px1920(1261);
          top: px1920(250);
          height: px1920(110);
          width: px1920(110);
          background: url("https://files.easy2walk.com/wwweasy2walk/img/pc/shop/tubiao.svg")
            center center no-repeat;
          background-size: 100% 100%;
        }
        .title {
          position: absolute;
          left: px1920(1086);
          top: px1920(373);
          font-size: px1920(44);
          color: #371b2f;
        }
        .text {
          position: absolute;
          left: px1920(1086);
          top: px1920(455);
          font-size: px1920(18);
          line-height: px1920(35);
          color: #371b2f;
          text-align: center;
          min-width: px1920(440);
        }
      }
      .pay {
        .shouji {
          position: absolute;
          left: px1920(970);
          top: px1920(79);
          height: px1920(649);
          width: px1920(336);
          background: url("https://files.easy2walk.com/wwweasy2walk/img/pc/pay/shouji.png")
            center center no-repeat;
          background-size: 100% 100%;
          z-index: 2;
        }
        .sucai {
          position: absolute;
          right: px1920(0);
          top: px1920(0);
          width: px1920(816);
          height: px1920(800);
          background: url("https://files.easy2walk.com/wwweasy2walk/img/pc/pay/sucai.png")
            center center no-repeat;
          background-size: px1920(816) px1920(800);
          z-index: 1;
        }
        .tubiao {
          position: absolute;
          left: px1920(616);
          top: px1920(250);
          height: px1920(110);
          width: px1920(110);
          background: url("https://files.easy2walk.com/wwweasy2walk/img/pc/pay/tubiao.svg")
            center center no-repeat;
          background-size: 100% 100%;
        }
        .title {
          position: absolute;
          left: px1920(441);
          top: px1920(373);
          font-size: px1920(44);
          color: #371b2f;
        }
        .text {
          position: absolute;
          left: px1920(441);
          top: px1920(455);
          font-size: px1920(18);
          line-height: px1920(35);
          color: #371b2f;
          min-width: px1920(440);
          text-align: center;
        }
      }
      .food {
        .shouji {
          position: absolute;
          left: px1920(827);
          top: px1920(79);
          height: px1920(649);
          width: px1920(336);
          background: url("https://files.easy2walk.com/wwweasy2walk/img/pc/food/shouji.png")
            center center no-repeat;
          background-size: 100% 100%;
        }
        .sucai {
          position: absolute;
          left: px1920(249);
          top: px1920(174);
          width: px1920(588);
          height: px1920(442);
          background: url("https://files.easy2walk.com/wwweasy2walk/img/pc/food/sucai.png")
            center center no-repeat;
          background-size: 100% 100%;
        }
        .tubiao {
          position: absolute;
          left: px1920(1341);
          top: px1920(250);
          height: px1920(110);
          width: px1920(110);
          background: url("https://files.easy2walk.com/wwweasy2walk/img/pc/food/tubiao.svg")
            center center no-repeat;
          background-size: 100% 100%;
        }
        .title {
          position: absolute;
          left: px1920(1235);
          top: px1920(373);
          font-size: px1920(44);
          color: #371b2f;
        }
        .text {
          position: absolute;
          left: px1920(1235);
          top: px1920(455);
          font-size: px1920(18);
          line-height: px1920(35);
          color: #371b2f;
          min-width: px1920(310);
          text-align: center;
        }
      }
      .youhui {
        .sucai {
          position: absolute;
          left: px1920(852);
          top: 0;
          width: px1920(493);
          height: px1920(800);
          // background: url("https://files.easy2walk.com/wwweasy2walk/img/pc/youhui/sucai.png") center center no-repeat;
          // background-size: 100% 100%;
          overflow: hidden;
          display: flex;
          justify-content: center;
          .imgItem {
            width: px1920(83);
            height: px1920(1032);
            margin: 0 auto;
            transform: translateY(px1920(-80));
            transition: transform 1.5s ease-in;
          }
          .imgTranslate {
            transform: translateY(px1920(0));
            &:nth-of-type(2n) {
              transform: translateY(px1920(-160));
            }
          }
        }
        .tubiao {
          position: absolute;
          left: px1920(552);
          top: px1920(250);
          height: px1920(110);
          width: px1920(110);
          background: url("https://files.easy2walk.com/wwweasy2walk/img/pc/youhui/tubiao.png")
            center center no-repeat;
          background-size: 100% 100%;
        }
        .title {
          position: absolute;
          left: px1920(470);
          top: px1920(373);
          font-size: px1920(44);
          color: #371b2f;
        }
        .text {
          position: absolute;
          left: px1920(345);
          top: px1920(455);
          font-size: px1920(18);
          line-height: px1920(35);
          color: #371b2f;
          min-width: px1920(515);
          text-align: center;
        }
      }

      .tuiguangItem {
        width: px1920(1920);
        height: px1920(770);
        background-color: #fff;
        position: relative;
        text-align: center;

        .topBg {
          width: 100%;
          height: px1920(520);
          background: url("https://files.easy2walk.com/wwweasy2walk/img/pc/haiwai/img1.png")
            center center no-repeat;
          background-size: 100% 100%;
        }
        .footBg {
          width: 100%;
          height: px1920(250);
          background: url("https://files.easy2walk.com/wwweasy2walk/img/pc/haiwai/img2.png")
            center center no-repeat;
          background-size: 100% 100%;
        }
        .phoneImg {
          width: px1920(336);
          height: px1920(650);
          position: absolute;
          top: px1920(76);
          left: px1920(303);
          background: url("https://files.easy2walk.com/wwweasy2walk/img/pc/haiwai/shouji1.png")
            center center no-repeat;
          background-size: 100% 100%;
          &:nth-of-type(2n) {
            background: url("https://files.easy2walk.com/wwweasy2walk/img/pc/haiwai/shouji2.png")
              center center no-repeat;
            background-size: 100% 100%;
            left: px1920(640);
          }
        }
        .title {
          font-size: px1920(44);
          position: absolute;
          top: px1920(172);
          left: px1920(1238);
          color: #fff;
        }
        .text {
          font-size: px1920(18);
          line-height: px1920(35);
          position: absolute;
          top: px1920(253);
          left: px1920(1076);
          color: #fff;
        }
      }
      .city {
        height: px1920(810);
        .topBg {
          background: url("https://files.easy2walk.com/wwweasy2walk/img/pc/city/img1.png")
            center center no-repeat;
          background-size: 100% 100%;
        }
        .footBg {
          height: px1920(290);
        }
        .phoneImg {
          top: px1920(108);
          left: px1920(955);
          background: url("https://files.easy2walk.com/wwweasy2walk/img/pc/city/shouji2.png")
            center center no-repeat;
          background-size: 100% 100%;
          &:nth-of-type(2n) {
            background: url("https://files.easy2walk.com/wwweasy2walk/img/pc/city/shouji1.png")
              center center no-repeat;
            background-size: 100% 100%;
            left: px1920(1292);
          }
        }
        .title {
          left: px1920(446);
        }
        .text {
          left: px1920(256);
        }
        .iconBox {
          width: px1920(670);
          position: absolute;
          top: px1920(458);
          left: px1920(210);
          .iconItem {
            display: inline-block;
            // width: px1920(116);
            margin-right: px1920(20);
            font-size: px1920(15);
            img {
              width: px1920(110);
              height: px1920(110);
              // animation: donghua1 2s linear infinite;
            }
            &:nth-of-type(2n) {
              img {
                // animation: donghua2 2s linear infinite;
              }
            }
            @-webkit-keyframes donghua1 {
              0% {
                transform: scale(1);
              }
              50% {
                transform: scale(1.1);
              }
              100% {
                transform: scale(1);
              }
            }
            @-webkit-keyframes donghua2 {
              0% {
                transform: rotateZ(0deg) scale(1.1);
              }

              50% {
                transform: rotateZ(0deg) scale(1);
              }

              100% {
                transform: rotateZ(0deg) scale(1.1);
              }
            }
          }
        }
      }
      .shangChangTuiGuang {
        width: px1920(1920);
        height: px1920(1150);
        background-color: #fff;
        position: relative;
        .topBg {
          width: 100%;
          height: px1920(520);
          background: url("https://files.easy2walk.com/wwweasy2walk/img/pc/shangchangtuiguang/bgImg.png")
            center center no-repeat;
          background-size: 100% 100%;
        }
        .title {
          font-size: px1920(44);
          position: absolute;
          top: px1920(60);
          left: px1920(868);
          color: #fff;
        }
        .text {
          font-size: px1920(18);
          line-height: px1920(35);
          width: px1920(546);
          text-align: center;
          position: absolute;
          top: px1920(142);
          left: px1920(687);
          color: #fff;
        }
        .shouji {
          position: absolute;
          left: px1920(776);
          top: px1920(226);
          height: px1920(663);
          width: px1920(359);
          text-align: center;
          // background: url("https://files.easy2walk.com/wwweasy2walk/img/pc/shangchangtuiguang/shouji.png") center
          //   center no-repeat;
          // background-size: 100% 100%;
          img {
            height: px1920(663);
            width: px1920(359);
          }
        }
        .imgItem {
          position: absolute;
          left: px1920(16);
          top: px1920(372);
          height: px1920(312);
          width: px1920(388);
          text-align: center;
          font-size: px1920(16);
          color: #371b2f;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .imgItem2 {
          left: px1920(404);
        }
        .imgItem3 {
          left: px1920(1116);
        }
        .imgItem4 {
          left: px1920(1507);
        }
        .saoma {
          position: absolute;
          right: 0;
          left: 0;
          text-align: center;
          font-size: px1920(14);
          color: #371b2f;
          top: px1920(883);
        }
        .bianjie {
          color: #371b2f;
          font-size: px1920(15);
          text-align: center;
          position: absolute;
          bottom: px1920(171);
          left: 50%;
          transform: translateX(-50%);
          .icon {
            width: px1920(12);
            height: px1920(9);
            background: url("https://files.easy2walk.com/wwweasy2walk/img/pc/shangchangtuiguang/icon.svg")
              center center no-repeat;
            background-size: 100% 100%;
            position: absolute;
            bottom: px1920(-17);
            left: 50%;
            transform: translateX(-50%);
          }
        }
        .serveIconBox {
          position: absolute;
          width: 100%;
          text-align: center;
          bottom: px1920(36);
          .serveIconItem {
            display: inline-block;
            color: #371b2f;
            font-size: px1920(15);
            margin: 0 px1920(40);
            img {
              width: px1920(69);
              height: px1920(69);
              margin-bottom: px1920(5);
            }
          }
        }
      }
      .footerBox {
        width: px1920(1920);
        height: px1920(433);
        background-color: #fff;
        position: relative;
        .bgBox {
          width: 100%;
          height: px1920(287);
          background: url("https://files.easy2walk.com/wwweasy2walk/img/pc/footer/bgImg.png")
            center center no-repeat;
          background-size: 100% 100%;
          position: relative;
          .telUs {
            font-size: px1920(44);
            color: #371b2f;
            position: absolute;
            top: px1920(94);
            left: 50%;
            transform: translateX(-50%);
          }
          .mallBox {
            font-size: 0;
            position: absolute;
            top: px1920(198);
            text-align: center;
            left: 50%;
            transform: translateX(-50%);
            img {
              width: px1920(26);
              height: px1920(18);
              margin-right: px1920(4);
            }
            span {
              font-size: px1920(22);
              color: #371b2f;
            }
            .icon {
              width: px1920(12);
              height: px1920(9);
              background: url("https://files.easy2walk.com/wwweasy2walk/img/pc/footer/icon.svg")
                center center no-repeat;
              background-size: 100% 100%;
              position: absolute;
              bottom: px1920(-16);
              left: 50%;
              transform: translateX(-50%);
            }
          }
          .mallBtn {
            display: block;
            font-size: px1920(22);
            color: #fff;
            background-color: #f05d52;
            border-radius: px1920(10);
            width: px1920(311);
            height: px1920(56);
            text-align: center;
            line-height: px1920(56);
            position: absolute;
            top: px1920(256);
            left: 50%;
            transform: translateX(-50%);
            z-index: 2;
            &:hover {
              background-color: #930c13;
            }
          }
        }
        .bottomBox {
          position: relative;
          width: 100%;
          height: px1920(146);
          .copy {
            position: absolute;
            top: px1920(0);
            left: px1920(27);
            font-size: px1920(14);
            height: px1920(146);
            line-height: px1920(146);
          }
          .beian {
            display: block;
            position: absolute;
            top: px1920(0);
            left: 50%;
            transform: translateX(-50%);
            font-size: px1920(14);
            height: px1920(146);
            line-height: px1920(146);
          }
          .mallBoxSmall {
            font-size: 0;
            position: absolute;
            top: px1920(0);
            left: 50%;
            transform: translateX(-50%);
            height: px1920(146);
            line-height: px1920(146);
            img {
              width: px1920(17);
              height: px1920(12);
              margin-right: px1920(4);
            }
            span {
              font-size: px1920(14);
            }
          }
          .logoBox {
            position: absolute;
            top: px1920(0);
            right: px1920(27);
            vertical-align: middle;
            height: px1920(146);
            line-height: px1920(146);
            .logoFenge {
              margin: 0 px1920(10);
              height: px1920(23);
              width: 1px;
            }
            .logoItem1 {
              // width: px1920(60);
              height: px1920(15);
            }
            .logoItem2 {
              // width: px1920(60);
              height: px1920(20);
            }
            .logoItem3 {
              // width: px1920(60);
              height: px1920(15);
            }
          }
        }
      }

      .text {
        animation-delay: 0.3s;
      }
    }
  }
}

/** iPad **/
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
  .shubiao {
    display: none;
  }
}
/** iPad pro**/
@media only screen and (min-device-width: 1024px) and (max-device-width: 1366px) {
  .shubiao {
    display: none;
  }
}

/** iPad 竖屏**/
@media all and (device-width: 768px) and (device-height: 1024px) and (orientation: portrait) {
  #mobile {
    display: block;
  }
  #pcBox {
    display: none;
  }
}
/** iPad 横屏**/
@media all and (device-width: 768px) and (device-height: 1024px) and (orientation: landscape) {
}

/* applies to lg also iPad 竖屏 */
@media only screen and (min-resolution: 132dpi) and (max-device-width: 1024px) and (orientation: portrait) {
  #mobile {
    display: block;
  }
  #pcBox {
    display: none;
  }
}
/* does not work on iPad or LG */
@media only screen and (device-aspect-ratio: 1024/768) and (orientation: portrait) {
}
</style>
